<button
  pButton
  severity="secondary"
  size="small"
  class="m-t-10"
  (click)="login()"
>
  Log in
</button>
